// ../../node_modules/.pnpm/@hiogawa+utils@1.4.2-pre.12/node_modules/@hiogawa/utils/dist/index.js
function tinyassert(value, message) {
  if (value) {
    return;
  }
  throw new TinyAssertionError(message, tinyassert);
}
var TinyAssertionError = class extends Error {
  constructor(message, stackStartFunction) {
    super(message);
    if ("captureStackTrace" in Error) {
      Error.captureStackTrace(this, stackStartFunction ?? TinyAssertionError);
    }
  }
};
var typedBoolean = Boolean;
function mapRegExp(input, regex, onMatch, onNonMatch) {
  let lastIndex = 0;
  for (const m of input.matchAll(regex)) {
    tinyassert(typeof m.index === "number");
    if (lastIndex < m.index) {
      onNonMatch(input.slice(lastIndex, m.index));
    }
    onMatch(m);
    lastIndex = m.index + m[0].length;
  }
  if (lastIndex < input.length) {
    onNonMatch(input.slice(lastIndex));
  }
}

export {
  tinyassert,
  typedBoolean,
  mapRegExp
};
